import type { Task } from '@cartwheel/api/v1'
import { formatDate } from '@cartwheel/string-utils'

export function TaskCompletionBanner({
  task,
  outcomeLabel,
}: {
  task: Task
  outcomeLabel?: string
}) {
  if (task.status !== 'completed' && task.status !== 'canceled') return null

  const isCompleted = task.status === 'completed'
  const heading = isCompleted ? 'Task completed' : 'Task canceled'
  const date = isCompleted ? task.completed_at : task.canceled_at
  const label = isCompleted ? 'Completed on' : 'Canceled on'

  return (
    <section className="space-y-3">
      <h3 className="text-base font-semibold leading-[1.5] text-charcoal">{heading}</h3>
      <div className="rounded-lg border border-sand bg-white p-4 shadow-sm">
        {outcomeLabel && (
          <p className="text-sm font-semibold leading-[1.5] text-charcoal">{outcomeLabel}</p>
        )}
        <p className="text-sm leading-[1.5] text-charcoal-50">
          {label} {formatDate(date)}
        </p>
      </div>
    </section>
  )
}
